<template>
  <div style="width: 100%;height: 100%">
    <el-row>
      <el-col :span="4">
        <el-button size="small" type="primary" @click="preview" v-show="this.printStatus === 1 && companyID !== 100">打印预览</el-button>
        <el-button style="margin-left: 20px" type="primary" size="small" @click="addOutWare" v-if="fun_dic[100040105]">补出库</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
      </el-col>
    </el-row>
    <el-row :data="titleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>供应商</span>：{{ titleData[0].SUPPLIER_NAME }}</li>
          <li><span>项目点</span>：{{ titleData[0].PROJECT_NAME }}</li>
          <li><span>项目点地址</span>：{{ titleData[0].ADDRESS }}</li>
          <li><span>送货日期</span>：{{ titleData[0].SEND_DAY }}</li>
          <li><span>订购总金额</span>：{{ titleData[0].TOTAL_SUPPLIER_FEE }}</li>
          <li><span>订单备注</span>：{{ titleData[0].ORDER_COMMENT }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>制单人</span>：{{ managername }}</li>
          <li><span>档口</span>：{{ titleData[0].DK_NAME }}</li>
          <li><span>项目点电话</span>：{{ titleData[0].TELPHONE }}</li>
          <li><span>订单编号</span>：{{ titleData[0].ORDER_CODE }}</li>
          <li><span>实收总金额</span>：{{ titleData[0].REAL_TOTAL_SUPPLIER_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-button style="margin-bottom: 20px" type="primary" @click="downloadAllBatchReport">批量下载批次报告</el-button>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" fixed="left" :selectable="selectable"></el-table-column>
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="SUPPLIER_REAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="分类"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column label="状态" prop="HAVE_RETURN"></el-table-column>
          <el-table-column label="已退货数量" prop="RETURN_COUNT"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="110">
            <template slot-scope="scope">
              <el-button type="text" @click="openAllEdit(scope.row)" v-show="fun_dic[100040101]">修改全部</el-button>
              <el-button type="text" @click="editProduct(scope.row)" v-show="fun_dic[100040102]">修改</el-button>
              <!-- 粤珍小厨 -->
              <el-button type="text" @click="editNeedCount(scope.row)" v-if="fun_dic[100040104]">修改送货数量</el-button>
              <!-- 亦芙德专用 -->
              <el-button type="text" size="small" @click="() => downloadBatchReport(scope.row)" :disabled="scope.row.BATCH_REPORT_ID == 0">
                下载批次报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :data="titleData">
        <el-button style="margin-top: 20px" type="primary" @click="retuenWare" v-show="fun_dic[100040103]"
          v-if="titleData[0].ORDER_TYPE == 2 || titleData[0].ORDER_TYPE == 3">退货</el-button>
      </el-col>
    </el-row>
    <el-row :data="titleData">
      <el-col>
        <p>收货时间：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <!-- 补出库 -->
    <el-dialog title="补出库" center :visible.sync="addFormVisible" width="600px">
      <el-form :model="addForm" ref="addForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <el-select filterable v-model="addForm.product" style="width:80%" remote :remote-method="remoteMethod" :clearable="true" :loading="loading"
            @change="insertTable">
            <el-option v-for="item in productList" :key="item.BATCH" :label="item.PRODUCT_NAME" :value="item.BATCH">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库日期：" :label-width="formLabelWidth">
          <el-date-picker v-model="addForm.DATE" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 360px"></el-date-picker>
        </el-form-item>
      </el-form>
      <el-table :data="resultData" border stripe>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="BATCH" label="批次"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="剩余库存"></el-table-column>
        <el-table-column prop="OUT_COUNT" label="出库数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.OUT_COUNT" @change="OutCount" @input.native="OutCount($event, scope.row)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteRecord(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 打印设置 -->
    <!-- 打印显示送货数量还是订购数量 -->
    <el-dialog title="打印项" center :visible.sync="printSetFormVisible" width="500px">
      <el-form>
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <el-radio v-model="printRadio" label="0">订购数量</el-radio>
          <el-radio v-model="printRadio" label="1">送货数量</el-radio>
        </el-form-item>
        <el-form-item label="单据类型：" :label-width="formLabelWidth">
          <el-radio v-model="docTypeRadio" label="0">长单子</el-radio>
          <el-radio v-model="docTypeRadio" label="1">短单子</el-radio>
        </el-form-item>
        <el-form-item label="是否打印实收：" :label-width="formLabelWidth">
          <el-radio v-model="printRealFlag" label="0">否</el-radio>
          <el-radio v-model="printRealFlag" label="1">是</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="printSetFormVisible = false">取 消</el-button>
        <el-button @click="submitPrint">打印</el-button>
      </div>
    </el-dialog>
    <!-- 修改全部信息 -->
    <el-dialog title="修改全部信息" center :visible.sync="editAllFormVisible" width="600px">
      <el-form :model="editAllForm" ref="editAllForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ Editname }}</span>
        </el-form-item>
        <el-form-item label="采购价：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.BUY_PRICE" @change="countPrice" :disabled="isisdisabled"></el-input>
        </el-form-item>
        <el-form-item label="报损后单价：" :label-width="formLabelWidth">
          <span> {{ editAllForm.WPRICE }}</span>
        </el-form-item>
        <el-form-item label="销售价：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.REAL_PRICE" :disabled="isisdisabled"></el-input>
        </el-form-item>
        <el-form-item label="订购数量：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.PRODUCT_COUNT"></el-input>
        </el-form-item>
        <el-form-item label="实收数量：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.REAL_COUNT"></el-input>
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.PRODUCT_COMMENT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <el-button @click="submitEditAll" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 退货模态框 -->
    <!-- TODO -->
    <el-dialog title="退货信息" center :visible.sync="returnVisible" width="90%" @close="handerClose()">
      <el-form :model="returnForm" ref="returnForm">
        <el-form-item label="退货日期：">
          <el-date-picker v-model="returnForm.RETURN_DATE" type="date" placeholder="选择日期" :picker-options="pickerOptions" :clearable="false">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-table :data="returnList" border ref="tableref">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="是否拆箱" align="center" prop="switchStatus" width="100">
          <template slot-scope="scope">
            <el-switch :disabled="scope.row.disabled" v-model="scope.row.switchStatus" @change="changeState($event, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus,PRODUCT_NAME" label="产品名称" min-width="100">
          <template slot-scope="scope">
            <span v-show="scope.row.switchStatus">{{ scope.row.unpackData.PRODUCT_NAME, }}</span>
            <span v-show="!scope.row.switchStatus">{{ scope.row.PRODUCT_NAME }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus,PRODUCT_CODE" label="产品编号" width="150">
          <template slot-scope="scope">
            <span v-show="scope.row.switchStatus">{{ scope.row.unpackData.PRODUCT_CODE, }}</span>
            <span v-show="!scope.row.switchStatus">{{ scope.row.PRODUCT_CODE }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus,TYPE_UNIT" label="单位" width="50">
          <template slot-scope="scope">
            <span v-show="scope.row.switchStatus">{{ scope.row.unpackData.TYPE_UNIT, }}</span>
            <span v-show="!scope.row.switchStatus">{{ scope.row.TYPE_UNIT }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus,NEED_COUNT" label="送货数量" width="80" align="center">
          <template slot-scope="scope">
            <span v-show="scope.row.switchStatus">---</span>
            <span v-show="!scope.row.switchStatus">{{ scope.row.NEED_COUNT }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus,unpackData.REAL_COUNT,REAL_COUNT" label="数量" width="130">
          <template slot-scope="scope">
            <span v-show="scope.row.switchStatus">拆箱后：{{ scope.row.unpackData.REAL_COUNT, }}</span>
            <span v-show="!scope.row.switchStatus">实收：{{ scope.row.REAL_COUNT }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退货数量" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COUNT" @input.native="Count($event, scope.row)" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="退货原因">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COMMENT"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="returnClose">取 消</el-button>
        <el-button size="small" @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" size="small" :rules="rules">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ this.editForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="单位：" :label-width="formLabelWidth">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <span>{{ this.editForm.TYPE_UNIT }}</span>
        </el-form-item>
        <el-form-item label="单价：" :label-width="formLabelWidth" prop="PROJECT_PRICE">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
          <el-input v-model="editForm.PROJECT_PRICE"></el-input>
        </el-form-item>
        <el-form-item label="实收数量：" :label-width="formLabelWidth" prop="REAL_COUNT">
          <el-input v-model="editForm.REAL_COUNT"></el-input>
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth" prop="PRODUCT_COMMENT">
          <el-input v-model="editForm.PRODUCT_COMMENT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('editForm')">取 消</el-button>
        <el-button size="small" @click="submitEdit('editForm')" :loading="loading1">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 待项目点确认订单修改产品送货数量 -->
    <el-dialog title="修改产品" center :visible.sync="editNeedCountFormVisible" width="600px">
      <el-form :model="editNeedCountForm" ref="editNeedCountForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ editNeedCountForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="送货数量：" :label-width="formLabelWidth">
          <el-input v-model="editNeedCountForm.NEED_COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editNeedCountFormVisible = false">取 消</el-button>
        <el-button @click="submitEditNeedCount">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  orderConfirmDetailFun, addOutFun, priceCountFun, updateOrderFun, modifyOrderFun, downloadOrderBatchReportFun, updateNewDetailFun_Limit,
} from 'api/sellOrder';
import { queryWarehouseFun } from 'api/warehouseManager';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import util from '../../assets/common/util';
import validation from '@/assets/common/validation';
import { downloadBatchReport } from '@/assets/api/shopOrderManage';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      status: 1,
      fromName: ['complementOutWarehouse', 'sellOrderPrintSelf', 'sellOrderPrint', 'toBeConfirmePrintDetail', 'HistoryOrderList'],
      toName: ['complementOutWarehouse', 'sellOrderPrintSelf', 'sellOrderPrint', 'toBeConfirmePrintDetail'],
      managername: sessionStorage.getItem('name'),
      tableData: [],
      titleData: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
          ORDER_TYPE: '',
        },
      ],
      printStatus: '',
      formLabelWidth: '120px',
      checkData: [],
      statusFlag: 0,
      companyID: Number(sessionStorage.getItem('tcid')),
      orderID: Number(sessionStorage.getItem('orderId')),
      addFormVisible: false,
      addForm: {},
      productList: [],
      loading: false,
      resultData: [],
      printSetFormVisible: false,
      printRadio: '0',
      docTypeRadio: '0',
      printRealFlag: '0',
      editAllFormVisible: false,
      editAllForm: '',
      Editname: '',
      checkedArray: [],
      returnVisible: false,
      returnForm: {
        RETURN_DATE: date(new Date(), '%F'),
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      returnList: [],
      CAN_MODIFY_PRICE: sessionStorage.getItem('CAN_MODIFY_PRICE'),
      isisdisabled: false,
      tmpArray: [],
      printSelfSetFormVisible: false,
      docTypeRadioSelf: '0',
      PAGE_ID: '1000401', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100040101: 0, 100040102: 0, 100040103: 0, 100040104: 0, 100040105: 0,
      },
      editFormVisible: false,
      editForm: {},
      rules: {
        PROJECT_PRICE: [
          { required: true, message: '请输入单价', trigger: 'blur' },
        ],
        REAL_COUNT: [
          { required: true, message: '请输入实收数量', trigger: 'blur' },
        ],
      },
      loading1: false,
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      editNeedCountForm: {},
      editNeedCountFormVisible: false,
    };
  },
  methods: {
    handerClose() {
      this.returnList.forEach((item) => {
        this.$set(item, 'COUNT', '');
      });
    },
    //
    changeState(switchStatus, row) {
      if (row.COUNT) {
        row.COUNT = '';
      }
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    returnClose() {
      this.returnVisible = false;
    },
    Count(e, row) {
      let unit = '';
      if (row.switchStatus === true) {
        unit = row.unpackData.TYPE_UNIT;
      } else {
        unit = row.TYPE_UNIT;
      }
      if (util.JudgmentUnit(unit)) {
        if (!validation.数量正数验证(Number(e.target.value))) {
          this.$message.show({ text: '请输入正确的价格', type: 'warning' });
          return;
        }
      } else {
        if (!validation.数量整数正数验证(Number(e.target.value))) {
          this.$message.show({ text: '请输入整数的价格', type: 'warning' });
          return;
        }
      }
      if (Number(row.REAL_COUNT) < Number(e.target.value) && row.switchStatus === false) {
        this.$message.show({ text: '退货数量不能大于实收数量!', type: 'warning' });
        e.target.value = 0;
        return;
      } if (Number(row.unpackData.REAL_COUNT) < Number(e.target.value) && row.switchStatus === true) {
        this.$message.show({ text: '退货数量不能大于拆箱后数量!', type: 'warning' });
        e.target.value = 0;
        return;
      }
      row.COUNT = e.target.value;
    },
    submitReturn() {
      const flag = this.returnList.find((item) => {
        if (!item.COUNT) {
          return true;
        }
      });
      if (flag) {
        this.$message.show({ text: '请输入退货数量', type: 'warning' });
        return false;
      }
      if (!this.returnForm.RETURN_DATE) {
        this.$message.show({ text: '请选择退货日期', type: 'warning' });
        return false;
      }
      const tmpArray = this.returnList.map((item) => {
        const tmpArrayItem = {};
        if (item.switchStatus === true) {
          tmpArrayItem.UN_PACK_PRODUCT = item.unpackData.PRODUCT_CODE;
        }
        tmpArrayItem.DETAIL_ID = item.ORDER_DETAIL_ID;
        tmpArrayItem.REASON = item.COMMENT || '';
        tmpArrayItem.RETURN_COUNT = Number(item.COUNT);
        tmpArrayItem.RETURN_DATE = date(this.returnForm.RETURN_DATE, '%F');
        return tmpArrayItem;
      });
      const params = {
        SERVICE_ID: '10028',
        OTYPE: 23,
        RETURN_LIST: tmpArray,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '申请成功', type: 'success' });
        this.queryOrderDetailListData();
        this.returnVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    // 退货
    retuenWare() {
      if (this.checkedArray.length !== 0) {
        this.returnList = this.checkedArray;
        this.returnVisible = true;
        const DETAIL_IDS = [];
        this.returnList.forEach((item) => {
          DETAIL_IDS.push(item.ORDER_DETAIL_ID);
          this.$set(item, 'unpackData', {});
          this.$set(item, 'switchStatus', false);
          this.$set(item, 'disabled', true);
        });
        const params = {
          SERVICE_ID: '10028',
          OTYPE: 28,
          DETAIL_IDS,
        };
        http.post(params).then((result) => {
          for (let i = 0; i < result.length; i++) {
            for (let j = 0; j < this.returnList.length; j++) {
              if (result[i].ORDER_DETAIL_ID == this.returnList[j].ORDER_DETAIL_ID) {
                this.returnList[j].unpackData = result[i];
                this.returnList[j].disabled = false;
                break;
              }
            }
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    // 多选框
    selectable(row, index) {
      if (row.REAL_COUNT == 0) {
        return false;
      }
      if (row.REAL_COUNT == row.RETURN_COUNT) {
        return false;
      }
      return true;
    },
    // -----------------------------------进入页面拉取数据
    queryOrderDetailListData() {
      const params = {
        ORDER_ID: this.orderID,
      };
      orderConfirmDetailFun(params).then((result) => {
        if (result[0].length !== 0) {
          this.tableData = result.length > 0 ? result[0].DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) })) : [];
          this.titleData = result.length > 0 ? result[0].TITLE : [];
          this.checkData = result.length > 0 ? result[0].OR[0].DATA : [];
          this.statusFlag = result.length > 0 ? result[0].OR[0].RN : 0;
          this.printStatus = 1;
          if (result[0].TITLE[0].AGENT) {
            sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
          } else {
            sessionStorage.setItem('AGENT', 0);
          }
          this.tableData.forEach((element) => { // tableData你的数据源
            switch (element.HAVE_RETURN) {
              case 1:
                element.HAVE_RETURN = '已退货';
                break;
              case 0:
                element.HAVE_RETURN = '未操作';
                break;
              default:
              // do nothing
            }
          });
        } else {
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    preview(row) {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        TC_ID: this.titleData[0].TC_ID,
        IS_SUPPLIER_CLIENT: 0,
      };
      http.post(params).then((result) => {
        if (result[0].USE_PRINT_TEMPLATE == 1) {
          this.$router.push({ name: 'toBeConfirmePrintDetail' });
          sessionStorage.setItem('TEM_TCID', this.titleData[0].TC_ID);
        } else {
          this.printSetFormVisible = true;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitPrint() {
      this.$router.push({ name: 'sellOrderPrint' });
      sessionStorage.setItem('countFlag', this.printRadio);
      sessionStorage.setItem('isShortDocFlag', this.docTypeRadio);
      sessionStorage.setItem('printRealFlag', this.printRealFlag);
    },
    submitPrintSelf() {
      this.$router.push({ name: 'sellOrderPrintSelf' });
      sessionStorage.setItem('countFlag', '9'); // 9表示不需要送货数量或者订购数量
      sessionStorage.setItem('isShortDocFlag', this.docTypeRadioSelf);
      sessionStorage.setItem('printRealFlag', '1'); // 自有订单需要打印实收数量
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        const params = {
          PRODUCT_NAME: query,
          PAGESIZE: 10000,
          PAGEINDEX: 0,
          SHOW: 0,
          FLAG: 0,
          WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
        };
        queryWarehouseFun(params).then((result) => {
          this.loading = false;
          if (result[0].TOTAL_COUNT !== 0) {
            this.productList = result[0].OP_ROLE.map((item) => Object.assign(item, { OUT_COUNT: '' }));
          } else {
            this.productList = [];
          }
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.productList = [];
      }
    },
    OutCount(e, row) {
      row.OUT_COUNT = e.target.value;
    },
    submitAdd() {
      if (!this.addForm.DATE) {
        this.$message.show({ text: '请选择出库日期', type: 'warning' });
        return false;
      }
      const submitArr = this.resultData.map((item) => ({
        PRODUCT_CODE: item.PRODUCT_CODE,
        PRODUCT_COUNT: item.OUT_COUNT == '' ? 0 : item.OUT_COUNT,
        BATCH: item.BATCH,
        LOCATION_ID: 0,
      }));
      if (submitArr.length == []) {
        this.$message.show({ text: '请补充出库产品列表', type: 'warning' });
        return false;
      }
      const params = {
        PRODUCTS_ARRAY: submitArr,
        ORDER_ID: this.orderID,
        DELIVER_DAY: this.addForm.DATE,
      };
      addOutFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.addFormVisible = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addOutWare() {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      if (this.checkedArray.length !== 0) {
        this.$router.push({ name: 'complementOutWarehouse', params: { ProductList: this.checkedArray, ORDER_ID: this.orderID } });
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
        return false;
      }
    },
    insertTable(e) {
      let tmpArr = [];
      tmpArr = this.productList.filter((item) => item.BATCH == e);
      this.resultData = this.resultData.concat(tmpArr);
    },
    deleteRecord(row) {
      const tableArr = this.resultData.filter((item) => item.BATCH !== row.BATCH);
      this.resultData = tableArr;
    },
    // 修改全部页面打开
    openAllEdit(row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }

      this.editAllFormVisible = true;
      this.editAllForm = row;
      this.Editname = row.PRODUCT_NAME;
    },
    // 修改页面全部关闭
    closeAll() {
      this.editAllFormVisible = false;
    },
    countPrice() {
      const params = {
        PRICE: this.editAllForm.BUY_PRICE,
        CATALOG_ID: this.editAllForm.CATALOG_ID,
      };
      priceCountFun(params).then((result) => {
        this.editAllForm.REAL_PRICE = result[0];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 全部提交
    submitEditAll() {
      if (this.$util.JudgmentUnit(this.editAllForm.TYPE_UNIT) ? !validation.数量正数验证(this.editAllForm.PRODUCT_COUNT) : !validation.数量整数正数验证(this.editAllForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正确的订购数量', type: 'warning' });
        return false;
      }
      if (this.$util.JudgmentUnit(this.editAllForm.TYPE_UNIT) ? !validation.数量正数0验证(this.editAllForm.REAL_COUNT) : !validation.数量整数正数0验证(this.editAllForm.REAL_COUNT)) {
        this.$message.show({ text: '请输入正确的实收数量', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_DETAIL_ID: this.editAllForm.ORDER_DETAIL_ID,
        NEW_COUNT: Number(this.editAllForm.PRODUCT_COUNT),
        MODIFY_FLAG: 1,
        PRICE: this.editAllForm.REAL_PRICE,
        PRODUCT_COMMENT: this.editAllForm.PRODUCT_COMMENT,
        SUPPLIER_ID: this.titleData[0].SUPPLIER_ID,
        PRODUCT_CODE: this.editAllForm.PRODUCT_CODE,
        REAL_NEW_COUNT: Number(this.editAllForm.REAL_COUNT),
      };
      if (!this.editAllForm.REAL_PRICE || !this.editAllForm.PRODUCT_COUNT || !this.editAllForm.REAL_COUNT) {
        this.$message.show({ text: '请填写销售价、订购数量和实收数量', type: 'warning' });
        return false;
      }
      this.loading = true;
      updateOrderFun(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editAllFormVisible = false;
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 亦芙德专用
    editProduct(row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }

      this.editFormVisible = true;
      this.editForm = row;
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (util.JudgmentUnit(this.editForm.TYPE_UNIT) ? !validation.数量正数0验证(this.editForm.REAL_COUNT) : !validation.数量整数正数0验证(this.editForm.REAL_COUNT)) { // 如果不是
            this.$message.show({ text: '请输入正确的实收数量', type: 'warning' });
            return false;
          }
          const updateParams = {
            ORDER_DETAIL_ID: Number(this.editForm.ORDER_DETAIL_ID),
            PRODUCT_CODE: this.editForm.PRODUCT_CODE,
            ORDER_ID: sessionStorage.getItem('orderId'),
            PRODUCT_COUNT: Number(this.editForm.REAL_COUNT),
            PRICE: this.editForm.PROJECT_PRICE,
            PRODUCT_COMMENT: this.editForm.PRODUCT_COMMENT,
          };
          this.loading1 = true;
          modifyOrderFun(updateParams).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.loading1 = false;
            this.editPriceFormVisible = false;
            this.editFormVisible = false;
            this.queryOrderDetailListData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.loading1 = false;
          });
        } else {
          return false;
        }
      });
    },
    close() {
      this.editFormVisible = false;
    },
    // 下载批次报告
    downloadBatchReport(row) {
      const params = {
        BATCH_REPORT_ID: row.BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((res) => {
        if (res[0]) {
          this.$message.show({ text: '下载成功', type: 'success' });
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        }
      });
    },
    downloadAllBatchReport() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      downloadOrderBatchReportFun(params).then((res) => {
        if (res.length) {
          this.$message.show({ text: '下载成功', type: 'success' });
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        } else {
          this.$message.show({ text: '订单内所有商品未上传批次报告', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    editNeedCount(row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }

      this.editNeedCountFormVisible = true;
      this.editNeedCountForm = { ...row };
    },
    submitEditNeedCount() {
      if (util.JudgmentUnit(this.editNeedCountForm.TYPE_UNIT) ? !validation.数量正数0验证(this.editNeedCountForm.NEED_COUNT) : !validation.数量整数正数0验证(this.editNeedCountForm.NEED_COUNT)) { // 如果不是
        this.$message.show({ text: '请输入正确的送货数量', type: 'warning' });
        return false;
      }
      const params = {
        DETAIL_ID: this.editNeedCountForm.ORDER_DETAIL_ID,
        NEED_COUNT: Number(this.editNeedCountForm.NEED_COUNT),
        TC_ID: this.titleData[0].TC_ID,
      };
      updateNewDetailFun_Limit(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editNeedCountFormVisible = false;
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从历史订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        // 控制是否可以自行修改价格
        if (Number(that.CAN_MODIFY_PRICE) === 1) {
          that.isisdisabled = false;
        } else {
          that.isisdisabled = true;
        }
        that.queryOrderDetailListData();
        that.queryBeforeFun();
      }
    });
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/historyOrderDetail.vue